import {put,takeLatest,call} from 'redux-saga/effects';

import {
    SET_TABLE,
    SET_TABLE_SUCCESS,
    SET_TABLE_ERROR
}
    from "../../actions/table";

function* setTableSaga(action) {
    try {
        yield put({
            type: SET_TABLE_SUCCESS,
            payload: action.payload.table
        });

    } catch(error) {
        yield put({
            type: SET_TABLE_ERROR,error: error.data
        });
    }
}


export function* setTableSagaWatcher() {
    yield takeLatest(SET_TABLE,setTableSaga);
}